/**
 * 로그인 화면에서 "최근 로그인" 표시용 힌트.
 * 인증 정보가 아니므로 로그아웃 후에도 유지됨 → localStorage 사용.
 *
 * 구조: { loginType: 'normal' | 'social', socialType: 'kakao' | 'naver' | 'google' | 'apple' | null }
 *
 * SNS 로그인은 외부 OAuth 리다이렉트를 거치므로 callback 시점에는 어떤 provider였는지 알 수 없음.
 * → SNS 시작 시점에 sessionStorage에 pending으로 보관, callback 성공 시 hint로 승격하는 패턴.
 */

const HINT_KEY = 'lastLoginHint'
const PENDING_KEY = 'pendingSocialType'

export const setLastLoginHint = (hint) => {
  try {
    localStorage.setItem(HINT_KEY, JSON.stringify(hint))
  } catch {}
}

export const getLastLoginHint = () => {
  try {
    const raw = localStorage.getItem(HINT_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export const setPendingSocialType = (provider) => {
  try {
    sessionStorage.setItem(PENDING_KEY, provider)
  } catch {}
}

export const consumePendingSocialType = () => {
  try {
    const value = sessionStorage.getItem(PENDING_KEY)
    sessionStorage.removeItem(PENDING_KEY)
    return value
  } catch {
    return null
  }
}
